// Live chat license
import { Pagination } from '../interface';

export const LIVE_CHAT_LICENSE = import.meta.env.VITE_LIVE_CHAT_LICENSE as string;

// GrowthBook fetures endpoint
export const GROWTHBOOK_API_HOST = 'https://cdn.growthbook.io';
export const GROWTHBOOK_API_KEY = import.meta.env.VITE_GROWTHBOOK_API_KEY as string;
export const BESTLIP_ANALYTICS_TIMER = import.meta.env.VITE_BETSLIP_ANALYTICS_TIMER;
export const AUTHOLOGIC_POLLING_INTERVAL = Number(import.meta.env.VITE_AUTHOLOGIC_POLLING_INTERVAL);
export const AUTHOLOGIC_TIMEOUT_LIMIT = Number(import.meta.env.VITE_AUTHOLOGIC_TIMEOUT_LIMIT);
export const NOTIFICATION_PERMISSION_RETRY_PERIOD_MINUTES = Number(import.meta.env.VITE_NOTIFICATION_PERMISSION_RETRY_PERIOD_MINUTES);

// BetAdmin
export const BETADMIN_TOKEN = import.meta.env.VITE_BETADMIN_TOKEN as string;

// API Base URL
export const API_BASE_URL = import.meta.env.VITE_API_URL;

export const FRONT_END_BASE_URL = window.location.origin;

export const ENCRYPTION_KEY = 'qwertyjkla2312safaaszAS';

export const KEEP_ALIVE_API_INTERVAL = 20000;
export const LIVE_EVENTS_FETCHING_INTERVAL = 24000;

export const MAX_WINNING = 500000;

export const SUPPORTED_IMAGE_FORMATS = ['image/png', 'image/jpeg', 'image/jpg'];

export enum StatscoreKeys {
	GENERIC_STATSCORE_PREMATCH = '615314ccfc65db257e294a58',
	GENERIC_STATSCORE_LIVE = '615314adfc65db2c41294a57',
	SKI_JUMPING_STATSCORE_KEY = '6380a0a984c2d2d24261c913',
	SPECIAL_STATSCORE_PREMATCH = 570,
	SPECIAL_STATSCORE_LIVE = 569,
}

//Static URL
const STATIC_FILES_URL = 'https://storage.betfan.pl';
export const MY_BET_REGULATION_URL = `${STATIC_FILES_URL}/regulations/2024_LIPIEC/240725RegulaminUslugiMYBET.pdf`;
export const COMPLAINT_FORM_URL = `${STATIC_FILES_URL}/regulations/formularz-reklamacyjny.pdf`;
export const RESPONSIBLE_GAMING = `${STATIC_FILES_URL}/regulations/Grajodpowiedzialnie.pdf`;

export enum SectionNavigation {
	HOME = 'home',
	LOGIN = 'login',
	COUPON = 'coupon',
	COUPON_LIST = 'coupon-list/:type/:page',
	COUPON_DETAILS = 'coupon-list/:type/:page/:couponId',
	REGISTRATION_METHOD = 'registration-method',
	REGISTRATION = 'registration/:stepId',
	FORGOT_PASSWORD = 'forgot-password',
	RESET_PASSWORD = 'reset-password',
	ACCOUNT_VERIFICATION_METHOD = 'account-verification-method',
	ACCOUNT_VERIFICATION = 'account-verification/:stepId',
	USER = 'user',
	CP_PERSONAL_DATA = 'user/personal-data',
	CP_CHANGE_PASSWORD = 'user/change-password',
	CP_BONUS = 'user/bonus',
	CP_BONUS_DISPLAY = 'user/bonus/:offerId',
	CP_MESSAGES = 'user/messages',
	CP_MESSAGES_DISPLAY = 'user/messages/:messageId',
	CP_COUPON = 'user/coupon',
	CP_COUPON_LIST = 'user/coupon/:type/:page',
	CP_COUPON_DETAILS = 'user/coupon/:type/:page/:couponId',
	CP_PROMO_CODE = 'user/promo-code',
	CP_DEPOSIT = 'user/deposit',
	CP_PAYOUT = 'user/payout',
	CP_MARKETING_CONSENT = 'user/marketing-consent',
	CP_RESPONSIBLE_GAME = 'user/responsible-game',
	CP_LIMITS = 'user/limits',
	CP_TRANSACTIONS = 'user/transactions',
	CP_ACTIVITIES = 'user/activities',
	CP_REGULATIONS = 'user/regulations',
	CP_PLayer_PROFILE = 'user/player-profile',
	CP_ACTIVITY_HISTORY = 'user/activity-history',
	CP_SETTINGS = 'user/settings',
	PAYMENTS = 'deposit/:stepId',
	DEPOSIT_PANEL = 'deposit-panel',
}

export const AKO = 'ako';
export const SYSTEM = 'system';
export const BETS = 'bets';

export const THEME = 'theme';
export enum AppTheme {
	AUTO = 'auto',
	DARK = 'dark',
	LIGHT = 'light',
}

export const MAIN_BALANCE = 'mainBalance';
export const BONUS_BALANCE = 'bonusBalance';
export const FREEBET = 'freebet';

export const ACCOUNT_STATUS_TEMP = 'TEMPORARY_ACCOUNT';
export const ACCOUNT_STATUS_ACTIVE = 'ACTIVE';
export const ACCOUNT_DOCUMENT_STATUS_ACCEPTED = 'ACCEPTED';
export const ACCOUNT_DOCUMENT_STATUS_REJECTED = 'REJECTED';
export const ACCOUNT_DOCUMENT_STATUS_TO_CHECK = 'TO_CHECK';
export const AWAITING_ADMIN_APPROVAL = 'AWAITING_ADMIN_APPROVAL';
export const ACCOUNT_DOCUMENT_STATUS_EXPIRED = 'EXPIRED';

export const ACC_VERIFICATION_STATUS = {
	temporary: 'TEMPORARY_ACCOUNT',
	active: 'ACTIVE',
	accepted: 'ACCEPTED',
	rejected: 'REJECTED',
	toCheck: 'TO_CHECK',
	awaiting: 'AWAITING_ADMIN_APPROVAL',
	expired: 'EXPIRED',
};

export const customerAccountStatus = {
	UNVERIFIED_ACCOUNT: 0,
	VERIFIED_ACCOUNT: 1,
};

const SUPPORTED_LANGUAGE = ['en'];

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const lang_url = window.location.pathname.split('/')[1]!;
const isSupportedLanguage = SUPPORTED_LANGUAGE.includes(lang_url);

export const currentLanguage = 'pl';

const { origin, pathname } = window.location;

if (isSupportedLanguage) {
	localStorage.setItem('lang', currentLanguage);
} else {
	if (lang_url.length === 2) {
		if (currentLanguage === 'pl' || lang_url === 'pl') {
			localStorage.setItem('lang', currentLanguage);
			window.location.replace(`${origin}${pathname}`.replace(`/${lang_url}`, ''));
		} else {
			window.location.replace(`${origin}${pathname}`.replace(lang_url, currentLanguage));
		}
	} else {
		localStorage.setItem('lang', 'pl');
	}
}

export const defaultBreakpoints = {
	0: {
		slidesPerView: 1.1,
	},
	480: {
		slidesPerView: 1.5,
	},
	650: {
		slidesPerView: 2.1,
	},
	900: {
		slidesPerView: 2.8,
	},
	1250: {
		slidesPerView: 1.1,
	},
};

export const vipLevelArray: any = {
	95: 1,
	94: 2,
	93: 3,
	92: 4,
	91: 5,
	99: 0,
	//values for test environment
	46: 1,
	47: 2,
	420: 3,
	418: 4,
	419: 5,
	796: 0,
};

export const vipStakes: Record<number, number> = {
	1: 100,
	2: 150,
	3: 200,
	4: 300,
	5: 400,
	0: 100,
};

export const CUSTOM_REGEX = {
	email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{1,})(\.[a-zA-Z0-9]{2,})?(\.[a-zA-Z0-9]{2,})?(\.[a-zA-Z0-9]{2,})?$/,
	password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[^`~()>'"\\]{8,}$/,
	phoneNumber: /^(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)$/,
	seriesAndIdNumber: /^[a-zA-Z]{3}[0-9]{6}$/,
	postalCode: /^[0-9]{2}[-]{1}[0-9]{3}$/,
	bankAccountNumber: /^[0-9 ]{26}$/,
	cardNumber: /^[0-9]{16}$/,
	peselNumber: /^(?=.*\d).{11}$/,
	blikCode: /^[0-9]{6}$/,
	cardExpiryDate: /^(0[1-9]|1[0-2])\/([0-9]{2})$/,
	cvv: /^[0-9]{3}$/,
	atLeastOneDigit: /\d/,
	atLeastTwoLetters: /[a-zA-Z]{2,}/,
};

const verificationMojeIdPrefix = '/weryfikacja/moje-id/';
export const APP_URL = {
	root: '/',
	home: '/zaklady-bukmacherskie',
	map: '/punkty-betfan',
	promotion: '/zaklady-bukmacherskie/promocje',
	login: '/logowanie',
	register: '/rejestracja',
	verification: '/weryfikacja',
	registrationForm: '/rejestracja/formularz',
	registrationMojeId: '/rejestracja/moje-id/:id',

	verificationMojeId: `${verificationMojeIdPrefix}:id`,
	verificationMojeIdPrefix: verificationMojeIdPrefix,

	forgotPassword: '/forgot-password',
	resetPassword: '/set-new-password',
	live: '/zaklady-live',
	sport: '/lista-zakladow',
	eSport: '/esport',
	oNas: '/o-nas',
	privacy: '/polityka-prywatnosci',
	contact: '/kontakt',
	payment: '/platnosci',
	entertainment: '/rozrywka',
	cardGames: '/gry-karciane',
	virtualSports: '/sporty-wirtualne',
	pageNotFound: '/404',
	deposit: '/wplata',
	chat: '/czat',
	todaysOffer: '/oferta-na-dzis',
	eventLive: '/event-live',
	preMatch: '/pre-match',
	coupon: '/kupon',
	slownik: '/slownik-gracza-co-warto-znac',
	usefulLinks: '/mapa-strony',
	certificateOfWinningInfo: '/zaswiadczenie-o-wygranej',
	myBet: '/my-bet',
	kodPromocyjnyBetfan: '/kod-promocyjny-betfan',
	aplikacjaMobilna: '/aplikacja-mobilna',
	activateAccount: '/activateAccount',
	betMarking: '/oznaczenia-do-zakladow',
	rangiVip: '/zaklady-bukmacherskie/promocje/rangi-vip',
	kuponKibica: '/kupon-kibica',
	shareKuponKibica: '/share-kupon-kibica',
	betMatch: '/zaklady-bukmacherskie/bet-match',
	playerProfile: '/zaklady-bukmacherskie/player-profile',
	chatVip: '/czat-vip',
	special: '/specjalne',
	horseRaceGame: '/zaklady-bukmacherskie/horse-race',
	pickEmGame: '/zaklady-bukmacherskie/pickem',
	dailyChallenge: '/zaklady-bukmacherskie/daily-challenge',
	regulations: '/regulamin',
	whatsNewInApp: '/conowego',
};
export const EXTERNAL_LINKS = {
	helpCenter: 'https://centrumpomocy.betfan.pl/',
	sportBetfan: 'https://sport.betfan.pl/',
};
export const SOCIAL_MEDIA_LINKS = {
	facebook: 'https://www.facebook.com/BETFANPL/',
	instagram: 'https://www.instagram.com/BETFAN_PL/',
	twitter: 'https://twitter.com/BETFANPL',
	youtube: 'https://www.youtube.com/@betfan7355',
	linkedin: 'https://pl.linkedin.com/company/betfan',
	tiktok: 'https://www.tiktok.com/@betfanpl',
};

export const PROMOTION_URL = {
	bonus200: `${APP_URL.promotion}/bonusy-bukmacherskie`,
	boost: `${APP_URL.promotion}/boost`,
	betBuilder: `${APP_URL.promotion}/betbuilder`,
	cashout: `${APP_URL.promotion}/promocje-cashout`,
};

export const THREE_COLUMN_URL = [
	APP_URL.home,
	APP_URL.live,
	APP_URL.sport,
	APP_URL.map,
	APP_URL.eSport,
	APP_URL.entertainment,
	// APP_URL.cardGames,
	APP_URL.virtualSports,
	APP_URL.pageNotFound,
	APP_URL.todaysOffer,
	APP_URL.eventLive,
	APP_URL.deposit,
	APP_URL.coupon,
	APP_URL.kuponKibica,
];

export const MARKETING_CONSENTS = {
	MARKETING_CONSENTS_EMAIL_ID: 2,
	MARKETING_CONSENTS_SMS_ID: 3,
};

export const TRACKER_TABS = {
	COURSES: 'All',
	BET_BUILDER: 'Builder',
};

export const SPORTS = {
	FOOTBALL: 1, // PIŁKA NOŻNA
	TENNIS: 5, // TENIS
	BASKETBALL: 2, // KOSZYKÓWKA
	BASKETBALL_3X3: 88, // Koszykówka 3x3
	ICE_HOCKEY: 4, // HOKEJ NA LODZIE
	VOLLYBALL: 10, // SIATKÓWKA
	HANDBALL: 6, // PIŁKA RĘCZNA
	HANDBALLBEACH: 376558, // PIŁKA RĘCZNA PLAZOWA
	F1: 11, //F1 / Sporty motorowe
	SPEEDWAY: 3181, // ŻUŻEL
	SKI_JUMPING: 48, //SKOKI NARCIARSKIE
	BASEBALL: 3, // Baseball
	BOWLS: 32, // BOWLING
	BOXING: 40, // Boks
	MMA: 41, // MMA
	DARTS: 22, // DARTS
	AUSSIE_RULES: 13, // Futbol australijski
	AM_FOOTBAL: 16, // Futbol amerykański
	FUTSAL: 29, // FUTSAL
	CRICKET: 21, // Krykiet
	CYCLING: 17, // kolarstwo
	SKIING: 43, //narciarstwo alpejskie
	BEACH_SOCCER: 60, // piłka nożna plażowa
	PESAPALLO: 61, // PESAPALLO
	RUGBY: 12, // Rugby
	BEACH_VOLLYBALL: 34, //siatkowka plazowa
	SNOOKER: 19, //Snooker
	TABLE_TENNIS: 20, // TENIS STOŁOWY
	ZAKLADY_SPECJALNE: 18, //Promocje
	FIELD_HOCKEY: 24, // Hokej na trawie
	ESPORT_FIFA: 1, // Esport Fifa
	BANDY: 15, // Bandy
	SQUASH: 37, // Squash
	FLOORBALL: 7, // Unihokej
	ATHLETICS: 36, // Lekkoatletyka
	BADMINTON: 31, // Badminton
	BIATHLON: 44, // Biathlon
	FIGURE_SKATING: 82, // Łyzwiarstwo figurowe
	WATER_POLO: 26, // Piłka wodna
	CROSS_COUNTRY_SKIING: 46, //biegi narciarskie
	CURLING: 28, //curling
	ARCHERY: 376515, //lucznictwo
	BOBSLEY: 45, //bobsleje
	CANOEING: 376512, //kajakarstwo
	CHESS: 4136, //szachy
	WATERJUMPING: 376527, //skoki do wody
	HORSEMANSHIP: 376516, //jezdziectwi
	FENCING: 376517, //szermierka
	FREESTYLE: 83, //freestyle
	GOLF: 9, //golf
	JUDO: 376519, //judo
	KABADDI: 6085, //kabaddi
	LUGE: 51, //saneczkarstwo
	PENTATHLON: 376520, //piecioboj-nowoczesny
	NORDIC: 47, //kombinacja-norweska
	OLYMPIC: 30, //igrzyska olimpijskie
	RAID: 515659, //rajdy
	ROWING: 64, //wioslarstwo
	SAILING: 81, //zeglarstwo
	SHORTTRACK: 85, //short-track
	SKATEBOARDING: 373692, //skateboarding
	SKELETON: 84, //skeleton
	SNOWBOARD: 49, //snowboard
	ICESKATING: 50, //lyzwiarstwo-szybkie
	MOTORSPORTS: 214262, //sporty-motorowe
	SUMO: 6165, //sumo
	SURFING: 90, //surfing
	SWIMMING: 373671, //plywanie
	TAEKWONDO: 376522, //taekwondo
	TRIATHLON: 376523, //triatlon
	WEIGHTLIFTING: 222800, //podnoszenie-ciezarow
	WRESTLING: 86, //wrestling
	CLIMBING: 514451, //wspinaczka-sportowa
	EUROPEAN_GAMES: 562479, //igrzyska-europejskie
	WBW: 630677, //wbb / wielka bitwa warszawska
	FISHING: 610429, //wędkarstwo
};

export const ESPORTS = {
	COUNTER_STRIKE: 70,
	LEAGUE_OF_LEGENDS: 71,
	DOTA2: 72,
	STAR_CRAFT: 73,
	OVERWATCH: 75,
	RAINBOW_SIX: 77,
	VALORANT: 11347,
	NBA2K: 80,
	CALL_OF_DUTY: 74,
	HEARTHSTONE: 76,
};

export const COUNTRY_CODES = [
	'AF',
	'AX',
	'AL',
	'DZ',
	'AS',
	'AD',
	'AO',
	'AI',
	'AQ',
	'AG',
	'AR',
	'AM',
	'AW',
	'AU',
	'AT',
	'AZ',
	'BS',
	'BH',
	'BD',
	'BB',
	'BY',
	'BE',
	'BZ',
	'BJ',
	'BM',
	'BT',
	'BO',
	'BA',
	'BW',
	'BV',
	'BR',
	'IO',
	'BN',
	'BG',
	'BF',
	'BI',
	'KH',
	'CM',
	'CA',
	'CV',
	'KY',
	'CF',
	'TD',
	'CL',
	'CN',
	'CX',
	'CC',
	'CO',
	'KM',
	'CG',
	'CD',
	'CK',
	'CR',
	'CI',
	'HR',
	'CU',
	'CY',
	'CZ',
	'DK',
	'DJ',
	'DM',
	'DO',
	'EC',
	'EG',
	'SV',
	'GQ',
	'ER',
	'EE',
	'ET',
	'FK',
	'FO',
	'FJ',
	'FI',
	'FR',
	'GF',
	'PF',
	'TF',
	'GA',
	'GM',
	'GE',
	'DE',
	'GH',
	'GI',
	'GR',
	'GL',
	'GD',
	'GP',
	'GU',
	'GT',
	'GG',
	'GN',
	'GW',
	'GY',
	'HT',
	'HM',
	'VA',
	'HN',
	'HK',
	'HU',
	'IS',
	'IN',
	'ID',
	'IR',
	'IQ',
	'IE',
	'IM',
	'IL',
	'IT',
	'JM',
	'JP',
	'JE',
	'JO',
	'KZ',
	'KE',
	'KI',
	'KP',
	'KR',
	'KW',
	'KG',
	'LA',
	'LV',
	'LB',
	'LS',
	'LR',
	'LY',
	'LI',
	'LT',
	'LU',
	'ME',
	'MO',
	'MK',
	'MG',
	'MW',
	'MY',
	'MV',
	'ML',
	'MT',
	'MH',
	'MQ',
	'MR',
	'MU',
	'YT',
	'MX',
	'FM',
	'MD',
	'MC',
	'MN',
	'MS',
	'MA',
	'MZ',
	'MM',
	'NA',
	'NR',
	'NP',
	'NL',
	'AN',
	'NC',
	'NZ',
	'NI',
	'NE',
	'NG',
	'NU',
	'NF',
	'MP',
	'NO',
	'OM',
	'PK',
	'PW',
	'PS',
	'PA',
	'PG',
	'PY',
	'PE',
	'PH',
	'PN',
	'PT',
	'PR',
	'QA',
	'RE',
	'RO',
	'RS',
	'RU',
	'RW',
	'SH',
	'KN',
	'LC',
	'PM',
	'VC',
	'WS',
	'SM',
	'ST',
	'SA',
	'SN',
	'CS',
	'SC',
	'SL',
	'SG',
	'SK',
	'SI',
	'SB',
	'SO',
	'ZA',
	'GS',
	'ES',
	'LK',
	'SD',
	'SR',
	'SJ',
	'SZ',
	'SE',
	'CH',
	'SY',
	'TW',
	'TJ',
	'TZ',
	'TH',
	'TL',
	'TG',
	'TK',
	'TO',
	'TT',
	'TN',
	'TR',
	'TM',
	'TC',
	'TV',
	'UG',
	'UA',
	'AE',
	'GB',
	'US',
	'UM',
	'UY',
	'UZ',
	'VU',
	'VE',
	'VN',
	'VG',
	'VI',
	'WF',
	'EH',
	'YE',
	'ZM',
	'ZW',
];

/**
 * Regulations type
 */
export const REGULATIONS_TYPES = {
	RESPONSIBLE_GAMING: 'responsibleGaming',
	PROMOTIONS: 'promotions',
	VIP: 'vip',
	PRIVACY: 'privacy',
	PRIVACY_POLICY: 'privacyPolicy',
	GDPR: 'gdpr',
} as const;

/**
 * placement screens
 */
export enum PLACEMENT_SCREENS {
	HOME = 'home',
	LIVE = 'live',
	SPORT = 'sport',
}

// payment modes
export const BLIK_PAYMENT = 'blik';
export const BANK_PAYMENT = 'bank';
export const CARD_PAYMENT = 'card';

// verification document types
export const PERSONAL_ID = 'id';
export const PASSPORT = 'passport';
export const STANDING_CARD_STAY = 'residenceCard';

/**
 * betradar stream types
 */
export enum BETRADAR_STREAM_TYPES {
	HLS = 'hls-manifest',
	DASH = 'dash-manifest',
}

/**
 * betradar device types
 */
export enum BETRADAR_DEVICE_TYPES {
	MOBILE = 'Mobile',
	DESKTOP = 'Desktop',
}

/**
 * live match status possible values
 */
export enum LiveMatchStatus {
	SIS_IN_PLAY = 'sis_in_play',
	SIS_NOT_STARTED = 'sis_not_started',
	FINISHED = 3,
	ON_GOING = 2,
}

export enum LiveEventOutcomeStatus {
	AWAITING_APPROVAL = 0,
}

/**
 * hide outcome odds which is less than this 1.01 only for this gameTypes instead of showing them as locked
 */
export const outcomeIdsToExclude = [190, 191, 100, 362];

export const MOBILE_BREAKPOINT = 1250;

export const ERROR_TYPES = {
	err404: '404',
	connectionLost: 'connectionLost',
	technicalBreak: 'technicalBreak',
};

export const TV_TRANSMISSION_ID = 9876543210;

export const specialLeaguesParentId = [396, 399];

export const specialEventsCategoryId = [
	214, 218, 230, 235, 244, 264, 276, 294, 361745, 510980, 595, 1073, 1507, 400, 403, 4627, 4819, 5603, 5722, 7045, 7234, 401, 397, 4572, 4804, 5550,
	5721, 7046, 7227, 697, 231, 418, 998, 1371, 1018, 2560, 70, 71, 544812,
];

export const SPORT_IDS_WITH_SPECIAL_SCORE_DISPLAY = [
	SPORTS.TENNIS,
	SPORTS.TABLE_TENNIS,
	SPORTS.BOWLS,
	SPORTS.DARTS,
	SPORTS.SQUASH,
	SPORTS.CRICKET,
	SPORTS.VOLLYBALL,
	SPORTS.BEACH_VOLLYBALL,
];

export const gameIdToNotShowBoldText = [-2527, -309, 1, 6, 201, 202, 2563, 2564];

export const TEMPORARY_ACCOUNT_ERRORCODE = 43; // error code which occurs when a temporary account hits a time limit to add funds to it.

export const googleMapsUrl = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=';

export const listOfSportIdToShowServingTeamBallIcon = [
	SPORTS.TENNIS,
	SPORTS.VOLLYBALL,
	SPORTS.DARTS,
	SPORTS.BEACH_VOLLYBALL,
	SPORTS.SNOOKER,
	SPORTS.TABLE_TENNIS,
	SPORTS.BADMINTON,
];

// TIME VALUES FOR USETIMER HOOK
export const SECOND = 1_000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;

export enum PaymentDrawerViews {
	DEPOSIT = 'deposit',
	CHOOSE_METHOD = 'choose-method',
	CHOOSE_BANK = 'choose-bank',
	SAVED_CARDS = 'saved-cards',
	ENTER_CARD_DETAILS = 'enter-card-details',
	ENTER_BLIK_NUMBER = 'enter-blik-number',
}

export enum PaymentProviderId {
	CARD = 274,
	BANK = 232,
	BLIK = 233,
	GOOGLE_PAY_NATIVE = 364,
}

export const UNIQUE_FIELD_VALIDATION_DEBOUNCE = 500;

export enum FastPaymentConfig {
	MAX_DEPOSIT_AMOUNT = 20,
	MIN_LAST_DEPOSIT = 10,
}

export const limitTypeMapping: any = {
	1: 'dailyStakeLimit',
	3: 'monthlyStakeLimit',
	13: 'dailyGameLimit',
	15: 'monthlyGameLimit',
	12: 'maxStakeLimit', // This information is not displayed on the front it's only available in the admin console. However, since SBB includes it in the endpoint, it's preferable to assign a defined value rather than having an undefined type.
};

export const reverseLimitTypeMapping: any = {
	dailyStakeLimit: 1,
	monthlyStakeLimit: 3,
	dailyGameLimit: 13,
	monthlyGameLimit: 15,
};

export const initialPaginationValues: Pagination = {
	page: 1,
	recordPerPage: 20,
	total: 0,
};

export const COMBINED_BET_MARKET_TYPE = 52;

export const pwaInstallConfig = {
	STORAGE_TIMESTAMP_KEY: 'installPwaTimestamp',
	REMINDER_AGAIN_IN_MINUTES: import.meta.env.VITE_INSTALL_PWA_REMINDER_AGAIN_IN_MINUTES || '43200',
};

export const campaignAIConfig = {
	AI_CAMPAIGN_EXPIRE_MINUTES: Number(import.meta.env.VITE_AI_CAMPAIGN_EXPIRE_MINUTES),
	STORAGE_SELECTION_KEY: 'registrationCampaignSelection',
};

export const WEEK_IN_MS = 1000 * 60 * 60 * 24 * 7;

export const WELCOME_OFFER_DEFAULT_VALUE = '200';

export const SELF_EXCLUSION_DAYS_NUMBER = 90;

export const promotionConfig = {
	AVAILABLE_AFTER_EXPIRED_IN_DAYS: 30,
};

export const APP_STORE_BETFAN_LINK = 'https://apps.apple.com/pl/app/betfan/id6742316416?l=pl';
export const triggerSurveyForUnverifiedUserConfig = {
	RUN_TRIGGER_AFTER_REGISTRATION_IN_DAYS: 7,
};

export const LOCK_COLORS = {
	incomplete: '#6A7373',
	complete: '#FFFFFF',
};
export const contentLoaderConfig = {
	backgroundColor: {
		light: '#fff',
		dark: '#202020',
	},
};
